import { TFunction } from "i18next";

export const getVehicleListTabs = (
  translate: TFunction<"translation", undefined>,
) =>
  [
    {
      value: translate("Tog"),
      label: translate("Søk på tognr, stasjon, linjenr eller sett-ID"),
    },
    {
      value: translate("Buss"),
      label: translate("Søk på skiftnr, stasjon, tlfnr eller tognr"),
    },
    {
      value: translate("Reservebuss"),
      label: translate("Søk på skiftnr, stasjon eller tlfnr"),
    },
  ] as const;
